import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

import store from '../store';

import { mySavedSearches } from '../actions/savedSearches';

import AnalyticsProvider from '../components/analytics/AnalyticsProvider';

import SearchProvider from '../components/search/SearchProvider';
import Search from '../components/search/Search';

const search = document.getElementById('search');
if (search) {
    store.dispatch(mySavedSearches());
    createRoot(search).render(
        <CookiesProvider>
            <Provider store={store}>
                <Router>
                    <AnalyticsProvider eventsApiOptions={{ timeout: 1000 }}>
                        <SearchProvider>
                            <Search />
                        </SearchProvider>
                    </AnalyticsProvider>
                </Router>
            </Provider>
        </CookiesProvider>
    );
}
